import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { IconContext } from "@phosphor-icons/react";
import { App } from "./App";
import { installVisibilityFlag } from "./hud/motion";
import "./styles/base.css";
import "./styles/controls.css";
import "./styles/scene.css";
import "./styles/auth.css";
import "./styles/threat.css";
import "./styles/pilot.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

// Pause every CSS loop (rings, sweep, pips, pulses) while the tab is hidden.
installVisibilityFlag();

createRoot(root).render(
  <StrictMode>
    <IconContext.Provider value={{ weight: "regular", size: 20 }}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IconContext.Provider>
  </StrictMode>,
);
